<template>
    <ul class="space-y-4 text-sm" v-if="resources.length">
        <li class="flex items-start" v-for="resource in resources">
            <div class="text-base">
                <h5 v-if="resource.vendors && resource.vendors.length" class="font-semibold">
                    {{ resource.vendors[0].display_name }}
                </h5>
                <button
                    @click.stop.prevent="getResource($event, resource)"
                    class="block text-left underline-offset-4 underline hover:text-red"
                >
                    {{ resource.name }}
                </button>
                <time class="text-sm text-gray-400">
                    <span class="sr-only">{{ $t('Updated') }}</span>
                    {{ DateTime.fromISO(resource.created_at).toLocaleString(DateTime.DATE_MED) }}
                </time>
            </div>
        </li>
    </ul>
</template>

<script setup>
import {DateTime} from 'luxon';
import {useResources} from "@/Composables";

const {getResource} = useResources();
const props = defineProps(['resources']);
</script>
